/* eslint-disable no-magic-numbers */
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Logo from "../logo/component";
import styles from "./styles.css";
import TransparentButton from "../button/transparent-button";
import { connect } from "react-redux";
import HeaderWhatsapp from "../header-whatsapp";

const MarketingHeader = ({
    location,
    buyCar
}) => {
    const isOfferPage = location.pathname.match("/offer/*");

    return (
        <div>
            <div styleName={"styles.mainHeader"}>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-md-12"} styleName={"styles.marketingHeaderWrapper"}>
                            <div className={"d-inline-block"} styleName={"styles.logo"}>
                                <Logo />
                            </div>
                            {!isOfferPage && <div styleName={`styles.headerRight`}>
                                <HeaderWhatsapp />
                                {buyCar.isBuyingOptionAvailable() &&  <TransparentButton onClick={() => buyCar.onclick()} text="BUY CAR" />}
                            </div> }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MarketingHeader.propTypes = {
    location: PropTypes.object,
    buyCar: PropTypes.object
};

const mapStateToProps = () => ({});

export default withRouter(connect(mapStateToProps, () => ({}))(MarketingHeader));
